var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaturniaEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.88 17.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9,17.72A6.25,6.25,0,0,1,6.25,5.36h0A2.42,2.42,0,0,1,4.73,7.64a4.27,4.27,0,0,0-2.61,5,4.21,4.21,0,0,0,3.13,3.13,4.25,4.25,0,0,0,5-2.62,2.43,2.43,0,0,1,2.28-1.52h0A6.26,6.26,0,0,1,4.9,17.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.22.64A2.31,2.31,0,0,0,14,.64L7.51,7.16A1.61,1.61,0,0,0,7.06,8l-.41,2a1,1,0,0,0,.27.93,1.06,1.06,0,0,0,.73.3l.2,0,2-.41a1.77,1.77,0,0,0,.84-.45l6.53-6.53a2.25,2.25,0,0,0,0-3.18ZM9.55,9.33l-1.28.26.3-1.37,4.85-4.85,1.07,1Zm6.61-6.57-.61.6-1.06-1,.61-.61a.75.75,0,0,1,.53-.22.77.77,0,0,1,.53.22.75.75,0,0,1,0,1.06Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaturniaEdit);
export default __webpack_public_path__ + "static/media/saturnia-edit.6aa2533a88aab591c12198e5be6c2e12.svg";
export { ForwardRef as ReactComponent };